module.exports = __webpack_public_path__ + "img/promo.f84188c.jpg";